import { FACE_ORDER } from './cube-config.js';
import { CENTER_INDICES_4X4 } from './cube-config-4x4.js';

function flatAddress(flatIndex) {
  const face = FACE_ORDER[Math.floor(flatIndex / 16)];
  return Object.freeze([face, flatIndex % 16]);
}

function freezeFaceletGroups(groups) {
  return Object.freeze(groups.map((group) => Object.freeze(group.map(flatAddress))));
}

// The order matches cs0x7f Threephase FullCube's public 96-facelet constructor.
// The public flat face order remains U, R, F, D, L, B.
export const CORNER_FACELETS_4X4 = freezeFaceletGroups([
  [15, 16, 35], [12, 32, 67], [0, 64, 83], [3, 80, 19],
  [51, 47, 28], [48, 79, 44], [60, 95, 76], [63, 31, 92],
]);

export const WING_FACELETS_4X4 = freezeFaceletGroups([
  [13, 33], [4, 65], [2, 81], [11, 17],
  [61, 94], [52, 78], [50, 46], [59, 30],
  [75, 40], [68, 87], [27, 88], [20, 39],
  [34, 14], [66, 8], [82, 1], [18, 7],
  [93, 62], [77, 56], [45, 49], [29, 55],
  [36, 71], [91, 72], [84, 23], [43, 24],
]);

export const CENTER_FACELETS_4X4 = Object.freeze(FACE_ORDER.flatMap((face) => (
  CENTER_INDICES_4X4.map((index) => Object.freeze([face, index]))
)));

export const CORNER_POSITION_NAMES_4X4 = Object.freeze(['UFR', 'ULF', 'UBL', 'URB', 'DFR', 'DLF', 'DBL', 'DRB']);
export const WING_POSITION_NAMES_4X4 = Object.freeze([
  'UF-a', 'UL-a', 'UB-a', 'UR-a', 'DB-a', 'DL-a', 'DF-a', 'DR-a',
  'LF-a', 'LB-a', 'RB-a', 'RF-a', 'UF-b', 'UL-b', 'UB-b', 'UR-b',
  'DB-b', 'DL-b', 'DF-b', 'DR-b', 'LF-b', 'LB-b', 'RB-b', 'RF-b',
]);

export function pieceKey4x4(faceLetters) {
  return [...faceLetters].sort().join('');
}

export const CORNER_PIECE_BY_KEY_4X4 = Object.freeze(Object.fromEntries(
  CORNER_FACELETS_4X4.map((facelets, index) => [pieceKey4x4(facelets.map(([face]) => face).join('')), index]),
));

export const WING_PIECE_BY_DIRECTED_KEY_4X4 = Object.freeze(Object.fromEntries(
  WING_FACELETS_4X4.map((facelets, index) => [facelets.map(([face]) => face).join(''), index]),
));

